
enum Suit {
    Spade = "Spade",
    Heart = "Heart",
    Diamond = "Diamond",
    Club = "Club",
    Blank = "",
}

export class CardModel {
    public cardId: number = 0;

    constructor (cardId: number) {
        this.cardId = cardId;
    }
  
    public get cardText() : string {
        return this.getSuitCode(this.cardId) + " " + this.getNumberCode(this.cardId);
    }

    public get imageName() : string {
        return this.getImageName(this.cardId);
    }

    /* public get cardSuit() {
        return this.getCardSuit(this.cardId);
    } */
    public get cardNumberCode() {
        return this.getNumberCode(this.cardId);
    }
    public get cardSuitCode() {
        return this.getSuitCode(this.cardId);
    }
    public get cardNumber() {
        return this.getCardNumber(this.cardId);
    }

    private getCardSuit(cardId: number) {
        if (cardId < 1)
            return Suit.Blank;
        else if (cardId < 14)
            return Suit.Club;
        else if (cardId < 27)
            return Suit.Diamond;
        else if (cardId < 40)
            return Suit.Heart;
        else if (cardId < 53)
            return Suit.Spade;
        return Suit.Blank;
    }

    private getSuitCode(cardId: number) {
        if (cardId < 1)
            return '';
        else if (cardId < 14)
            return 'C';
        else if (cardId < 27)
            return 'D';
        else if (cardId < 40)
            return 'H';
        else if (cardId < 53)
            return 'S';
        return '';
    }

    private getCardNumber(cardId: number) {
        while (cardId > 13)
        {
            cardId = cardId -13;
        }
        return cardId;
    }

    private getNumberCode(cardId: number) {
        while (cardId > 13)
        {
            cardId = cardId -13;
        }
        if (cardId === 1)
            return "A";
        else if (cardId === 2)
            return "2";
        else if (cardId === 3)
            return "3";
        else if (cardId === 4)
            return "4";
        else if (cardId === 5)
            return "5";
        else if (cardId === 6)
            return "6";
        else if (cardId === 7)
            return "7";
        else if (cardId === 8)
            return "8";
        else if (cardId === 9)
            return "9";
        else if (cardId === 10)
            return "10";
        else if (cardId === 11)
            return "J";
        else if (cardId === 12)
            return "Q";
        else if (cardId === 13)
            return "K";

            return "";
    }

    private getImageName(cardId: number) {
        let filename = 'Empty';
        let cardSuit = this.getCardSuit(cardId);
        
        if (cardSuit === Suit.Club) {
            filename = '_club'; 
        }
        else if (cardSuit === Suit.Diamond) {
            filename = '_diamond';
        }
        else if (cardSuit === Suit.Heart) {
            filename = '_heart';
        }
        else if (cardSuit === Suit.Spade) {
            filename = '_spade';
        }
        
        while (cardId > 13)
        {
            cardId = cardId -13;
        }
        if (cardId === 1)
            filename = 'A' + filename;
        else if (cardId === 2)
            filename = '2' + filename;
        else if (cardId === 3)
            filename = '3' + filename;
        else if (cardId === 4)
            filename = '4' + filename;
        else if (cardId === 5)
            filename = '5' + filename;
        else if (cardId === 6)
            filename = '6' + filename;
        else if (cardId === 7)
            filename = '7' + filename;
        else if (cardId === 8)
            filename = '8' + filename;
        else if (cardId === 9)
            filename = '9' + filename;
        else if (cardId === 10)
            filename = '10' + filename;
        else if (cardId === 11)
            filename = 'J' + filename;
        else if (cardId === 12)
            filename = 'Q' + filename;
        else if (cardId === 13)
            filename = 'K' + filename;

        return filename;
    }

     /* public get cardName() : string {
        return this.getSuitName(this.cardSuit) + " " + this.getNumberName(this.cardId);
    } */

    /* public getSuitName(cardSuit: Suit) {
        if (cardSuit=== Suit.Spade)
            return "Spade";
        else if (cardSuit === Suit.Heart)
            return "Heart";
        else if (cardSuit === Suit.Diamond)
            return "Diamond";
        else if (cardSuit === Suit.Club)
            return "Club";
        return "";
    } */

       /* private getNumberName(cardNumber: number) {
        while (cardNumber > 13)
        {
            cardNumber = cardNumber -13;
        }
        if (cardNumber === 1)
            return "Ace";
        else if (cardNumber === 2)
            return "Two";
        else if (cardNumber === 3)
            return "Three";
        else if (cardNumber === 4)
            return "Four";
        else if (cardNumber === 5)
            return "Five";
        else if (cardNumber === 6)
            return "Six";
        else if (cardNumber === 7)
            return "Seven";
        else if (cardNumber === 8)
            return "Eight";
        else if (cardNumber === 9)
            return "Nine";
        else if (cardNumber === 10)
            return "Ten";
        else if (cardNumber === 11)
            return "Jack";
        else if (cardNumber === 12)
            return "Queen";
        else if (cardNumber === 13)
            return "King";

            return "";
    } */

        /* public getCardId(cardSuit: Suit, cardNumber: number): number {
        if (cardNumber > 13)
            return 0;
        else if (cardNumber < 1)
            return 0;
        else if (cardSuit === Suit.Club)
            return cardNumber;
        else if (cardSuit === Suit.Diamond)
            return cardNumber + 13;
        else if (cardSuit === Suit.Heart)
            return cardNumber + 26;
        else if (cardSuit === Suit.Spade)
            return cardNumber + 39;
        return 0;
    } */

}